import styles from './OurClients.module.css'

const clients = ['Stella Maris', 'Ocean', 'VOLVE', 'TB REVIEW', 'POLAR']

const OurClients = () => {
  return (
    <section className={styles.ourClients}>
      <div className={styles.header}>
        <h2 className={styles.title}>OUR CLIENTS</h2>
        <p className={styles.subtitle}>
          We believe every client is a valuable<br />long-term partner.
        </p>
      </div>

      <div className={styles.marqueeWrapper}>
        <div className={styles.marquee}>
          {[...clients, ...clients, ...clients].map((client, index) => (
            <span key={index} className={styles.clientName}>
              {client}
            </span>
          ))}
        </div>
      </div>
    </section>
  )
}

export default OurClients
